module.exports = __webpack_public_path__ + "static/media/home-stage-x2.085fe509.jpg";